import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import servicesData from '../data/servicesData';

const Services = () => {
  return (
    <section id="services" className="section-padding">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-primary font-medium text-sm tracking-wider uppercase">
            What I Offer
          </span>
          <h2 className="section-title mt-2">
            My <span className="text-primary">Services</span>
          </h2>
          <p className="section-subtitle">
            Comprehensive professional services designed to help you succeed in
            your career and beyond.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className={`group bg-gradient-to-br ${service.color} rounded-3xl p-8 hover:shadow-xl transition-all duration-500 hover:-translate-y-1 border border-white/50`}
            >
              <div
                className={`w-14 h-14 ${service.iconBg} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <service.icon className={`text-2xl ${service.iconColor}`} />
              </div>
              <h3 className="text-xl font-display font-bold text-text-dark mb-3">
                {service.title}
              </h3>
              <p className="text-text-light leading-relaxed mb-6">
                {service.heroDescription.substring(0, 150)}...
              </p>
              <div className="grid grid-cols-2 gap-2 mb-6">
                {service.features.map((feature, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                    <span className="text-sm text-text-light">{feature}</span>
                  </div>
                ))}
              </div>
              <Link
                to={`/services/${service.slug}`}
                className="inline-flex items-center gap-2 text-primary-dark font-medium text-sm hover:text-primary transition-colors duration-300 group/link"
              >
                Learn More
                <HiArrowRight className="group-hover/link:translate-x-1 transition-transform duration-300" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
